import { ReactNode, useState, useRef, useCallback, useEffect } from 'react'

import { useLocation } from 'react-router'

import { TransmissionContext, INITIAL_STATE, TransmissionState } from './transmissionContext'

import UrlHelper from 'common/helpers/url'
import { Referer } from 'common/types'
import { HTMLHotModalElement } from 'modules/transmission/components/configMenuMobile'
import {
  CreatedFrom,
  MobileTab,
  TransmissionInfo,
  OnFireLanguageResponse,
  Visibility,
  Provider
} from 'modules/transmission/types'

interface Props {
  children: ReactNode,
  state?: TransmissionState
}

export const TransmissionProvider = ({ children, state }: Props) => {
  const { search } = useLocation()

  const [transmissionCode, setTransmissionCode] = useState(INITIAL_STATE.transmissionCode)
  const [activeTab, setActiveTab] = useState<MobileTab | undefined>(INITIAL_STATE.activeTab)
  const [loading, setLoading] = useState(INITIAL_STATE.loading)
  const [transmissionData, setTransmissionData] = useState<TransmissionInfo>(INITIAL_STATE.transmissionData)
  const [onFireLanguages, setOnFireLanguages] = useState<OnFireLanguageResponse[]>([])
  const [isClub, setIsClub] = useState<boolean>(INITIAL_STATE.isClub)

  const languageModalRef = useRef<HTMLHotModalElement>(null)

  const isOnFire = transmissionData.createdFrom === CreatedFrom.ON_FIRE
  const isPrivate = [
    Visibility.PRIVATE,
    Visibility.HOTMART
  ].includes(transmissionData.visibility)

  const isHotmartProvider = [
    Provider.HOTMART,
    Provider.MUX_STUDIO_HOTMART
  ].includes(transmissionData.provider)

  const openLanguageModal = useCallback(() => languageModalRef.current?.openModal(), [])

  useEffect(() => {
    setIsClub(UrlHelper.getQueryParam(search, 'referer') === Referer.CLUB)
  }, [search])

  return (
    <TransmissionContext.Provider value={{
      transmissionCode,
      setTransmissionCode,
      activeTab,
      setActiveTab,
      transmissionData,
      setTransmissionData,
      loading,
      setLoading,
      isPrivate,
      isOnFire,
      openLanguageModal,
      onFireLanguages,
      setOnFireLanguages,
      showOnfireLanguages: Boolean(isOnFire && onFireLanguages?.length),
      isClub,
      setIsClub,
      languageModalRef,
      isHotmartProvider,
      ...state
    }}>
      {children}
    </TransmissionContext.Provider>
  )
}
